export class Parallax {
    constructor(elem) {
        this.elem = elem instanceof HTMLElement ? elem : (elem[0] || elem);
        this.onResize();
        this.objectPosition = Math.max(0, Math.min(1, 1 - (this.elementTop - this.trackTop) / this.trackHeight));
        this.trackPosition = Math.max(0, Math.min(1, 1 - (this.elementTop - this.trackTop) / this.trackHeight));
        window.addEventListener("scroll", (event) => this.onScroll(event), { passive: true });
        window.requestAnimationFrame(() => this.tick());
        window.addEventListener("resize", () => this.onResize());
    }
    getOffsetTop(element) {
        return element.getBoundingClientRect().top + window.scrollY;
    }
    getOuterHeight(element) {
        const styles = window.getComputedStyle(element);
        const marginTop = parseFloat(styles.marginTop) || 0;
        const marginBottom = parseFloat(styles.marginBottom) || 0;
        return element.offsetHeight + marginTop + marginBottom;
    }
    onScroll(event) {
        this.elementTop = this.getOffsetTop(this.elem);
        this.elementHeight = this.getOuterHeight(this.elem);
        this.elementBottom = this.elementTop + this.elementHeight;
        this.screenBottom = window.scrollY + window.innerHeight;
        this.screenTop = window.scrollY;
        this.trackTop = this.screenTop - this.elementHeight;
    }
    onResize() {
        this.elementTop = this.getOffsetTop(this.elem);
        this.elementHeight = this.getOuterHeight(this.elem);
        this.elementBottom = this.elementTop + this.elementHeight;
        this.screenBottom = window.scrollY + window.innerHeight;
        this.screenTop = window.scrollY;
        this.trackHeight = window.innerHeight + this.elementHeight + 130;
        this.trackTop = this.screenTop - this.elementHeight;
    }
    amIOnScreen() {
        return this.screenBottom > this.elementTop - 130 && this.screenTop < this.elementBottom;
    }
    lerp(start, end, amt) {
        return (1 - amt) * start + amt * end;
    }
    tick() {
        if (!this.amIOnScreen()) {
            window.requestAnimationFrame(() => this.tick());
            return;
        }
        this.objectPosition = Math.max(0, Math.min(1, 1 - (this.elementTop - this.trackTop) / this.trackHeight));
        this.trackPosition = this.lerp(this.trackPosition, this.objectPosition, 0.15);
        if (this.elem instanceof HTMLImageElement || this.elem instanceof HTMLVideoElement) {
            this.elem.style.objectPosition = "50% " + (1 - this.trackPosition) * 100 + "%";
        }
        window.requestAnimationFrame(() => this.tick());
    }
}
